<template>
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11.625" cy="11" r="11" fill="#7A7A7A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.4511 13.0494L12.7882 6.66083C12.5519 6.24801 12.1262 6.00105 11.6494 6H11.6473C11.1726 6 10.7484 6.24487 10.5116 6.65403L6.80301 13.0431C6.56566 13.4523 6.56566 13.9394 6.80301 14.3475C7.04036 14.7562 7.46505 15 7.93922 15H15.3106C15.7837 15 16.2079 14.7572 16.4453 14.3507C16.6826 13.9447 16.6852 13.4581 16.4511 13.0494Z"
      fill="white" />
  </svg>
</template>
